import React from "react";
import { TagColor } from "../../../../app/data/common/tagColor";
import Tag from "../../../../ui-components/molecules/tag/tag";

export const STATUS_ACTIONS = {
    "2": "Auto Indexed",
    "6": "Deleted",
    "8": "Import Review",
    "9": "Imported",
    "10": "Inspected",
    "4": "Manually Indexed",
    "11": "Missing",
    "1": "New",
    "5": "Passed",
    "7": "Purge",
    "3": "Review"
};
export const LOCATION_ACTIONS = {
    "49": "Agent - Actx",
    "50": "Agent - Aewr",
    "53": "Agent - Aghv",
    "75": "Agent - AllStarFreight",
    "52": "Agent - Averitt",
    "54": "Agent - Bdsf",
    "51": "Agent - Brtc",
    "63": "Agent - Crew2",
    "55": "Agent - Diam",
    "56": "Agent - Eagl",
    "57": "Agent - Easy",
    "77": "Agent - EnterpriseFreight",
    "73": "Agent - GroundFreightExpress",
    "58": "Agent - Hath",
    "71": "Agent - Hathlou",
    "64": "Agent - Nebt",
    "62": "Agent - Pga",
    "66": "Agent - Pgak",
    "78": "Agent - PsePcd",
    "59": "Agent - Puls",
    "76": "Agent - RedlineFreight",
    "83": "Agent - Sefl",
    "60": "Agent - Shea",
    "61": "Agent - Thsv",
    "65": "Agent - Xpo",
    "41": "Agents",
    "44": "Albany",
    "2": "Albuquerque",
    "82": "Allentown",
    "4": "Anaheim",
    "7": "Aurora",
    "80": "Brownstown",
    "95": "Calhoun",
    "86": "Cartersville",
    "84": "Charlotte",
    "43": "Chattanooga",
    "90": "Chattanooga2",
    "67": "CheetahPod",
    "91": "Cleveland",
    "85": "Clinton",
    "70": "Columbus",
    "24": "Coraopolis",
    "89": "Dalton",
    "92": "Dayton",
    "18": "Eagan",
    "74": "EagleEnterprises",
    "10": "Fresno",
    "93": "GrandRapids",
    "8": "Grapevine",
    "3": "GuilderlandCtr",
    "6": "Hanover",
    "19": "Hayward",
    "12": "Houston",
    "47": "Import",
    "81": "Indianapolis",
    "13": "Jacksonville",
    "29": "Kent",
    "69": "Lakeland",
    "14": "LittleRock",
    "28": "Louisville",
    "17": "Loxley",
    "21": "Markham",
    "32": "MarylandHeights",
    "16": "MenomoneeFalls",
    "68": "Miami",
    "87": "NewOrleans",
    "20": "OklahomaCity",
    "15": "Orlando",
    "23": "Phoenix",
    "96": "Pod-External",
    "22": "Portland",
    "31": "RanchoCordova",
    "34": "Riverview",
    "25": "Rochester",
    "9": "Romulus",
    "46": "Sacramento",
    "30": "SaltLakeCity",
    "27": "SanAntonio",
    "26": "SanDiego",
    "11": "Spokane",
    "94": "Springfield",
    "1": "System",
    "48": "Testing",
    "88": "Tracy",
    "35": "Tulsa",
    "33": "TunnelHill",
    "72": "WarehouseReceipts",
    "5": "Windsor",
    "79": "Youngstown"
};
export const DOCUMENT_TYPE_ACTIONS = {
    "1": "ATH",
    "2": "Bills Of Landing",
    "12": "Credit",
    "3": "Customer",
    "4": "Deleted After Import",
    "5": "EDI",
    "6": "Invoice",
    "10": "Manifest",
    "7": "Miscellaneous",
    "8": "No Document Type",
    "9": "Proof Of Delivery",
    "11": "Unknown",
    "13": "Warehouse Receipt"
};
export const getDocTypeTag = (unit: string) => {
    let color;
    let label;

    switch (unit.toUpperCase()) {
        case "CRT":
            color = TagColor.PURPLE;
            label = "CRT";
            break;
        case "ATH":
            color = TagColor.OLIVE;
            label = "ATH";
            break;
        case "BOL":
            color = TagColor.GREEN;
            label = "BOL";
            break;
        case "CUS":
            color = TagColor.NAVY;
            label = "CUS";
            break;
        case "DAI":
            color = TagColor.MAGENTA;
            label = "DAI";
            break;
        case "EDI":
            color = TagColor.TEAL;
            label = "EDI";
            break;
        case "MAN":
            color = TagColor.MAROON;
            label = "MAN";
            break;
        case "INV":
            color = TagColor.ORANGE;
            label = "INV";
            break;
        case "NDT":
            color = TagColor.RED;
            label = "NDT";
            break;
        case "MSC":
            color = TagColor.YELLOW;
            label = "MSC";
            break;
        case "POD":
            color = TagColor.BLUE;
            label = "POD";
            break;
        case "UNK":
            color = TagColor.RED;
            label = "UNK";
            break;
        default:
            color = TagColor.GREY;
            label = unit;
            break;
    }

    return <Tag mods={{ color }}>{label}</Tag>;
};
export const getIndexTag = (unit: string) => {
    let color;
    let label;

    switch (unit.toLowerCase()) {
        case "review":
            color = TagColor.PURPLE;
            label = "Review";
            break;
        case "purge":
            color = TagColor.OLIVE;
            label = "Purge";
            break;
        case "auto indexed":
            color = TagColor.GREEN;
            label = "Auto Indexed";
            break;
        case "import review":
            color = TagColor.NAVY;
            label = "Import Review";
            break;
        case "inspected":
            color = TagColor.TEAL;
            label = "Inspected";
            break;
        case "missing":
            color = TagColor.MAROON;
            label = "Missing";
            break;
        case "imported":
            color = TagColor.MAGENTA;
            label = "Imported";
            break;
        case "passed":
            color = TagColor.ORANGE;
            label = "Passed";
            break;
        case "deleted":
            color = TagColor.RED;
            label = "Deleted";
            break;
        case "new":
            color = TagColor.YELLOW;
            label = "New";
            break;
        case "manually indexed":
            color = TagColor.BLUE;
            label = "Manually Indexed";
            break;
        default:
            color = TagColor.GREY;
            label = unit;
            break;
    }

    return <Tag mods={{ color }}>{label}</Tag>;
};